import { render, staticRenderFns } from "./UpdateAP.vue?vue&type=template&id=833a95f8&scoped=true"
import script from "./UpdateAP.vue?vue&type=script&lang=js"
export * from "./UpdateAP.vue?vue&type=script&lang=js"
import style0 from "./UpdateAP.vue?vue&type=style&index=0&id=833a95f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833a95f8",
  null
  
)

export default component.exports